export default __webpack_public_path__ + "static/media/event-4.535a84e8.JPG";